import React from 'react';
import { Grid, Card, Header, Segment, Label, Table, Button } from 'semantic-ui-react'
import {
  capitalize as _capitalize,
  orderBy as _orderBy
} from 'lodash';

import './RequestInfoNew.less'
import { IN_TRIAL } from '../../constants/SellerSubscriptionStatus';

class RequestInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  get formPages() {
    const { serviceRequestInfo } = this.props || {};
    if (!serviceRequestInfo) {
      return [];
    }
    return _orderBy(serviceRequestInfo.formPages, 'pageOrder');
  }

  getSortedSection = (page = {}) => {
    const { sections } = page;
    if (!sections) {
      return [];
    }
    return _orderBy(sections, 'sectionOrder');
  };

  applyBottomBorderMobile = (fieldsLength, index) => {
    if (fieldsLength <= 2) {
      return false;
    } else {
      // even number of fields.
      if (fieldsLength % 2 == 0 && (fieldsLength - 1 == index || fieldsLength - 2 == index)) {
        return false;
      } else if (fieldsLength % 2 != 0 && (fieldsLength - 1 == index)) {
        // odd number of fields.
        return false;
      }
      else {
        return true;
      }
    }
  }
  applyBottomBorderDesktop = (fieldsLength, index) => {
    if (fieldsLength <= 4) {
      return false;
    } else {
      // even number of fields.
      if (fieldsLength % 2 == 0 && (fieldsLength - 1 == index || fieldsLength - 2 == index || fieldsLength - 3 == index || fieldsLength - 4 == index)) {
        return false;
      } else if (fieldsLength % 2 != 0 && (fieldsLength - 1 == index)) {
        // odd number of fields.
        return false;
      }
      else {
        return true;
      }
    }
  }

  render() {

    const renderSections = (page, pi) => {
      const sections = this.getSortedSection(page).filter((section) => { return section.isHidden != true });
      return (<React.Fragment key={`sfd_page_${pi}`}>

        <Grid key={"grid-" + pi}>
          <Grid.Row key={"row-" + pi}>
            <Grid.Column key={"col-" + pi} width={16}>
              {sections.map((section, si) => {
                let { fields = [] } = section;
                fields = [...fields.filter((field) => { return field.isHidden != true })]
                if (section.type === 'radio') {
                  return (<div className="section">
                    <div className="section-header">
                      {_capitalize(section.headerText)}
                    </div>
                    <Grid key={"radio-grid-section-" + si} className={"value-grid"}>
                      <Grid.Row key={"radio-row-section-" + si}>
                        <Grid.Column key={"radio-col-section-" + si} width={16} className="content-column removeRightBorder">
                          {fields.map((field) => {
                            if (field.value === 'checked') {
                              return <p>{field.name}</p>;
                            }
                            return null;
                          })}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>

                  </div>)
                }
                else if (section.type == 'multi') {
                  return (<div className="section">
                    <div className="section-header">
                      {_capitalize(section.headerText)}
                    </div>
                    <Grid key={"multi-grid-section" + si} className={"value-grid"}>
                      <Grid.Row key={"multi-row-section-" + si}>
                        {fields.map((field, fi) => {
                          return (<Grid.Column key={"multi-col-" + fi + "-sec" + si} computer={4} tablet={8} mobile={16} className="content-column removeRightBorder" >
                            <p>{_capitalize(field.name)}</p>
                            <div className="value">{field.value == 'checked' ? "Yes" : "No"}</div>
                          </Grid.Column>
                          )
                        })}
                      </Grid.Row>
                    </Grid>
                  </div>)
                }
                else {
                  return (<div className="section">
                    <div className="section-header">
                      {_capitalize(section.headerText)}
                    </div>
                    <Grid key={"text-grid-section" + si} className={"value-grid"}>
                      <Grid.Row key={"text-row-section-" + si}>
                        {fields.map((field, fieldIndex) => {
                          return (<Grid.Column key={"text-field-col-" + fieldIndex + "-sec" + si} computer={4} mobile={fields.length == 1 ? 16 : 8}
                            className={`content-column ${this.applyBottomBorderMobile(fields.length, fieldIndex) || this.applyBottomBorderDesktop(fields.length, fieldIndex) ? " bottomBorder" : ""}  ${fields.length == 1 ? "removeRightBorder" : ""}`}>
                            <p> {_capitalize(field.name)}</p>
                            <div className="value">{field.value}</div>
                          </Grid.Column>
                          )
                        })}
                      </Grid.Row>
                    </Grid>
                  </div>)
                }
              })
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>


      </React.Fragment>)
    }

    return (
      <div className="request-info-new">

        <div className={"upper-header"}>
          {this.props.title ? <div className={"title"}>{this.props.title}</div> : ''}
          {!this.props.hideMoreInfo && <div className='right'>
            {
              (
                (
                  window.innerWidth > 1023
                  && this.props.buyerMobileNo
                  && this.props.sellerDetail
                  && this.props.sellerDetail.subStatus == IN_TRIAL
                )
                || (
                  window.innerWidth > 1023
                  && this.props.isUnAuthorized == true
                )
              )
              &&
              <div >
                <div className={"buyer-mobile-container"}>
                  <div className={"icon-container"}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.453" height="13.355" viewBox="0 0 13.453 13.355">
                      <defs>
                        <clipPath id="clip-path">
                          <rect id="Rectangle_8721" data-name="Rectangle 8721" width="13.453" height="13.355" fill="#377dff" />
                        </clipPath>
                      </defs>
                      <g id="Group_15588" data-name="Group 15588" transform="translate(0 0)">
                        <g id="Group_15588-2" data-name="Group 15588" transform="translate(0 0)" clipPath="url(#clip-path)">
                          <path id="Path_41833" data-name="Path 41833" d="M3.072.1q.589.586,1.174,1.176l.694.7a.518.518,0,0,1,0,.8c-.424.417-.851.832-1.272,1.254a.3.3,0,0,0-.076.186,4.1,4.1,0,0,0,.419,1.841A6.3,6.3,0,0,0,7.926,9.576a3.449,3.449,0,0,0,1.2.187.313.313,0,0,0,.227-.1c.41-.416.824-.828,1.236-1.241a.517.517,0,0,1,.811-.005q.932.93,1.862,1.863a.517.517,0,0,1,.075.731A8.674,8.674,0,0,1,12,12.67a2.215,2.215,0,0,1-.978.606,5.532,5.532,0,0,1-.66.079,6.589,6.589,0,0,1-2.372-.566A12.6,12.6,0,0,1,5.04,10.977a16.6,16.6,0,0,1-3.4-3.662A10.135,10.135,0,0,1,.23,4.417,7.188,7.188,0,0,1,.012,3.165,2.179,2.179,0,0,1,.726,1.309,9.81,9.81,0,0,1,2.407,0" transform="translate(0)" fill="#377dff" />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className={"number-container"}>
                    {"Customer Info:"} &nbsp; <span> {this.props.buyerName} </span>  &nbsp;  <span> {this.props.buyerMobileNo ? this.props.buyerMobileNo : ""} </span>
                  </div>
                </div>
              </div>}
          </div> }
          {!this.props.hideMoreInfo && window.innerWidth > 1023 ? <div className={"submit-btn-container"}>
            <Button className="button-submit-green" onClick={this.props.onMoreInfoClick}>Have Questions? Click here</Button>
          </div> : ''}
        </div>
        {this.formPages.map((page, pi) => renderSections(page, pi))}
      </div >
    )
  }
}
export default RequestInfo;